import React, { forwardRef, useRef, useState } from 'react';

import classNames from 'classnames';

import { CodeLanguage } from '../../../../types';
import { mergeRefs } from '../../../utils';
import { CodeBlockCopyButton } from '../CodeBlockCopyButton';

import * as classes from './style.module.scss';

interface Props {
  codeLanguage: CodeLanguage | string;
  codeBlockIndex?: number;
  onMouseEnter?: React.MouseEventHandler<HTMLPreElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLPreElement>;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const CodePre = forwardRef<HTMLPreElement, Props>(
  (
    {
      codeLanguage,
      codeBlockIndex,
      onMouseEnter,
      onMouseLeave,
      style,
      className,
      children,
    },
    ref,
  ) => {
    const codeRef = useRef<HTMLPreElement | null>(null);
    const [showCopyButton, setShowCopyButton] = useState(false);

    const handleMouseEnter: React.MouseEventHandler<HTMLPreElement> = event => {
      if (onMouseEnter) {
        onMouseEnter(event);
      }
      setShowCopyButton(true);
    };

    const handleMouseLeave: React.MouseEventHandler<HTMLPreElement> = event => {
      if (onMouseLeave) {
        onMouseLeave(event);
      }
      setShowCopyButton(false);
    };

    return (
      <pre
        ref={mergeRefs(ref, codeRef)}
        className={classNames(classes.root, className)}
        style={style}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <CodeBlockCopyButton
          show={showCopyButton}
          codeLanguage={codeLanguage}
          codeRef={codeRef}
          codeBlockIndex={codeBlockIndex}
        />
        {children}
      </pre>
    );
  },
);

CodePre.displayName = 'CodePre';

export { CodePre };
